import IntegrtiasLogo from '../assets/logos/IntegritasLogo.svg';
import GradientBackground from '../components/GradientBackground/GradientBackground';
import UploadBox from '../components/StampData/UploadBox';

const StampData = () => {
  // FIXME n remove animation on validatestate   ${!disableAnimation && !validateState && 'animate-slide-in-up'}
  return (
    // Header 100px + margin 60px *2 = 220px
    <main className="relative m-[10px] p-[4px] sm:m-[20px] sm:p-[8px] md:m-[60px] md:p-[112px] flex items-center justify-between overflow-hidden bg-slate-grey">
      {/* Background inside main but behind content */}
      <GradientBackground />

      {/* Foreground Content - Ensure it is above the background */}
      <div
        className="relative z-10 flex items-center justify-center w-full 
      gap-5 flex-col lg:flex-row lg:gap-20"
      >
        <UploadBox />
        <section className="flex flex-col justify-center text-white w-full max-w-[415px] px-4 sm:px-0">
          <img
            src={IntegrtiasLogo}
            className="animate-slide-up-main h-[50px] w-[200px] sm:h-[70px] sm:w-[270px]"
          />
          <div className="animate-slide-up-main pt-[20px] sm:pt-[40px]">
            <p className="text-xl sm:text-2xl font-normal mb-3 sm:mb-4">
              Stamp data to generate a verifiable proof on the Minima blockchain.
            </p>
            <div className="text-sm sm:text-base font-normal space-y-3">
              <p>
                <strong>How to stamp data:</strong>
              </p>
              <ol className="space-y-2 ml-2">
                <li className="grid grid-cols-[auto_1fr] gap-3">
                  <span className="text-white w-4">1.</span>
                  <span className="self-end">
                    Upload your files here to create a verifiable proof
                  </span>
                </li>
                <li className="grid grid-cols-[auto_1fr] gap-3">
                  <span className="text-white w-4">2.</span>
                  <span className="self-end">
                    Go to <strong>History → Stamps</strong>
                  </span>
                </li>
                <li className="grid grid-cols-[auto_1fr] gap-3">
                  <span className="text-white w-4">3.</span>
                  <span className="self-end">
                    Check proof and download your <strong>proof file</strong> once stamp is on chain
                  </span>
                </li>
                <li className="grid grid-cols-[auto_1fr] gap-3">
                  <span className="text-white w-4">4.</span>
                  <span className="self-end">
                    Use the <strong>Analyze</strong> page to upload your <strong>proof file</strong>{' '}
                    and validate your data
                  </span>
                </li>
              </ol>
              <p className="mt-4 text-xs sm:text-xs">
                By submitting your data, you confirm that you have obtained consent from the data
                owner or have the lawful authority to do so. Additionally, you agree that Minima may
                use this data for analytics, tool enhancement, and research purposes.
              </p>
            </div>
          </div>
        </section>
      </div>
    </main>
  );
};

export default StampData;
